export default function makeMinWidthMediaQuery(breakpoint) {
  return `@media screen and (min-width: ${breakpoint}px)`
}
